export default __webpack_public_path__ + "ubisoft-playtest-profile-icon-smiley-white.webp";